// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u0u2gc{margin-left:var(--ds-space-100,8px)}\n._19pk1y44{margin-top:4px}\n._1bsbidpf{width:0}\n._1e0c1txw{display:flex}\n._1i531tmw{border-top-color:var(--ds-text-danger,#ae2e24)}\n._1kl71rn1{border-left:4px solid transparent}\n._1o3iy73q{border-bottom-color:var(--ds-text-success,#216e4e)}\n._1s7z1rn1{border-right:4px solid transparent}\n._2hwxyh40{margin-right:2px}\n._4t3iidpf{height:0}\n._n7zldirs{border-bottom:8px solid}\n._x3dodirs{border-top:8px solid}", ""]);
// Exports
module.exports = exports;
